import About from '../components/About/About';


export default function PublicRoutes() {
  return [      
      { path: "/about", element: <About /> },
    ]
}